/*
 * File: TeamDetailsCard.tsx
 * Project: a-a
 * File Created: Monday, 20th January 2025 7:49:00 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 27th October 2025 10:56:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomCard from '../../shared/CustomCard/CustomCard';
import zeplinColor from '../../../theme/Color';
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';

const TeamDetailsCard = ({ loading = false }: { loading?: boolean }) => {
  const theme = useTheme();
  const screenHeight = window.innerHeight;
  let selectedMember: any = {};
  const storedMember = sessionStorage.getItem('selected-member');
  if (storedMember) {
    selectedMember = JSON.parse(storedMember);
  }
  return (
    <CustomCard
      styles={{
        // borderRadius: '14px',

        height: '100%',
        // screenHeight > 1000
        //   ? '58vh'
        //   : screenHeight > 650
        //   ? '54vh'
        //   : screenHeight > 500
        //   ? '35vh'
        //   : '32vh',
        backgroundColor: zeplinColor.Neutral1,
        borderWidth: `1px 1px 1px 1px`,
        borderStyle: 'solid',
        borderColor: `${zeplinColor.Neutral5}`,
        borderRadius: '14px 14px 14px 14px',
        overflowY: 'scroll',
      }}
    >
      {' '}
      <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '20px', xl: '24px' } }}>
          <Typography variant='responsiveHeading2'>Personal Details</Typography>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              {/* <img
                src='/assets/account-name.svg'
                width={20}
                height={20}
                style={{ objectFit: 'fill' }}
              /> */}
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Name
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selectedMember?.name ?? 'N/A'}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              {/* <img
                src='/assets/relationship.svg'
                width={20}
                height={20}
                style={{ objectFit: 'fill' }}
              /> */}
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Role
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box sx={{ flex: 3, display: 'flex', gap: '8px' }}>
                  <Chip
                    label={
                      <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                        {selectedMember?.position ?? 'N/A'}
                      </Typography>
                    }
                    sx={{
                      backgroundColor: zeplinColor.BasicBlack,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      // width: '47px',
                      height: '24px',
                      '&.MuiChip-root': {
                        // flex: 1,
                      },
                    }}
                  />
                  {selectedMember?.title && (
                    <Chip
                      label={
                        <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                          {selectedMember?.title ?? 'N/A'}
                        </Typography>
                      }
                      sx={{
                        backgroundColor: zeplinColor.BasicBlack,
                        padding: '5px 12px 5px 12px',
                        borderRadius: '50px',
                        // width: '47px',
                        height: '24px',
                        '&.MuiChip-root': {
                          // flex: 1,
                        },
                      }}
                    />
                  )}
                </Box>
              )}
            </Box>
          </Box>

          <Typography variant='responsiveHeading2'>Contact Details</Typography>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Mobile
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selectedMember?.mobile ?? 'N/A'}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              {/* <img src='/assets/mobile.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Phone
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selectedMember?.phone ?? 'N/A'}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              {/* <img src='/assets/email.svg' width={20} height={20} style={{ objectFit: 'fill' }} /> */}
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Email
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selectedMember?.email ?? 'N/A'}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Address
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selectedMember?.address?.street ? '' : 'N/A'}
                  {selectedMember?.address?.street ? `${selectedMember?.address?.street},` : ''}
                  {selectedMember?.address?.city ? ` ${selectedMember?.address?.city},` : ''}
                  {selectedMember?.address?.state ? ` ${selectedMember?.address?.state},` : ''}
                  {selectedMember?.address?.country ? ` ${selectedMember?.address?.country},` : ''}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

export default TeamDetailsCard;
